import { useEffect } from "react";

const MARTER_SERVER = process.env.REACT_APP_MARTER_SERVER || "https://server.getmarter.com";

export default function CollectorEmbed() {
  useEffect(() => {
    const script = document.createElement("script");
    script.src = `${MARTER_SERVER}/collector/bundle`;
    script.async = true;

    let cancelled = false;

    script.onload = function () {
      if (cancelled) return;
      if (typeof window.__pxCollect !== "function") return;
      window.__pxCollect().catch(function () {});
    };

    document.head.appendChild(script);

    return () => {
      cancelled = true;
      try {
        document.head.removeChild(script);
      } catch {
        // already removed
      }
    };
  }, []);

  return null;
}
